module.exports = {
    ATTR : '$',
    CHAR : '_'
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/schema/consts.js
// module id = 463
// module chunks = 1